<ng-container *ngIf="schedulersData">
    <div class="px-24 py-16">
        <div class="d-flex flex-row align-items-center justify-content-between">
            <div class="d-flex flex-column" style="width: 474px">
                <div class="d-flex align-items-center mb-8">
                    <div class="mat-body-2 text-black m-0 section-heading">{{ schedulersData.title }}</div>
                    <span 
                        class="info-tooltip material-icons-outlined ml-4"
                        (mouseover)="!popOverMenuTrigger.menuOpen && popOverMenuTrigger.openMenu()" 
                        >info
                        <button 
                            #popOverMenuTrigger="matMenuTrigger" 
                            [matMenuTriggerFor]="popOverMenu" 
                            class="hidden"
                        ></button>
                        <mat-menu #popOverMenu="matMenu" class="info-menu-panel px-20 py-12" (click)="$event.stopPropagation()">
                            <div (mouseleave)="popOverMenuTrigger.menuOpen && popOverMenuTrigger.closeMenu()" (click)="$event.stopPropagation()" class="mat-subtitle-2">
                                {{schedulersData.tooltip}}
                            </div>
                        </mat-menu>
                    </span>
                </div>
                <div class="mat-subtitle-2 text-hint m-0">
                    {{ schedulersData.description }}
                </div>
            </div>
    
            <button mat-flat-button color="accent" (click)="openSheet()" class="mx-8">
                <mat-icon>add</mat-icon>
                <span class="px-5">{{ schedulersData.createBtnLabel }}</span>
            </button>
        </div>
        
        <ng-container *ngIf="schedulersData?.warnNote?.length">
            <ng-container 
                *ngTemplateOutlet="contentWithLinkTemp; context: {data: schedulersData.warnNote}"
                ></ng-container>
        </ng-container>
        <ng-container *ngIf="formErrors?.duplicateSurveyTime?.length">
            <ng-container 
                *ngTemplateOutlet="contentWithLinkTemp; context: {data: formErrors.duplicateSurveyTime}"
                ></ng-container>
        </ng-container>
        <ng-container *ngIf="formErrors?.inValidRerunTime?.length">
            <ng-container 
                *ngTemplateOutlet="contentWithLinkTemp; context: {data: formErrors?.inValidRerunTime}"
                ></ng-container>
        </ng-container>
    </div>

    
    <table *ngIf="scheduleValues?.length" class="form-exp-table" style="width: 100%;" mat-table [dataSource]="scheduleValues">
    
        <ng-container [matColumnDef]="schedulersData.tableHeaderLabels[0]">
            <th mat-header-cell *matHeaderCellDef class="x1large">{{schedulersData.tableHeaderLabels[0]}}</th>
            <td mat-cell *matCellDef="let data" class="x1large">{{ data.value | momentTimezonePipe: timeZoneData.timezone_identifier : dateTimeFormats.mediumDateTimeWithMinDay }}</td>
        </ng-container>
        <ng-container [matColumnDef]="schedulersData.tableHeaderLabels[1]">
            <th mat-header-cell *matHeaderCellDef class="x2large">{{schedulersData.tableHeaderLabels[1]}}</th>
            <td mat-cell *matCellDef="let data" class="x2large">{{ data.createdBy }}</td>
        </ng-container>
        <ng-container [matColumnDef]="schedulersData.tableHeaderLabels[2]">
            <th mat-header-cell *matHeaderCellDef class="xlarge">{{schedulersData.tableHeaderLabels[2]}}</th>
            <td mat-cell *matCellDef="let data" class="xlarge">
                <div 
                    *ngIf="data.status" 
                    style="margin: 0px auto !important" 
                    [class]="'text-badge ' + data.status.class"
                >
                    <div class="mat-caption m-0">{{data.status.value | uppercase}}</div>
                </div>
            </td>
        </ng-container>
        <ng-container [matColumnDef]="schedulersData.tableHeaderLabels[3]">
            <th mat-header-cell *matHeaderCellDef class="xlarge text-right">{{schedulersData.tableHeaderLabels[3]}}</th>
            <td mat-cell *matCellDef="let data" class="xlarge actions text-right">
                <button 
                    [color]="!!data.disabled ? '' : 'warn'" 
                    mat-icon-button 
                    [disabled]="!!data.disabled" 
                    (click)="removeSchedule(data.value)"
                 >
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="schedulersData.tableHeaderLabels"></tr>
        <tr mat-row class="row-hover" *matRowDef="let row; columns: schedulersData.tableHeaderLabels"></tr>
    </table>

    <ng-template #sheetTemp>
        <div *ngIf="schedulersData?.formData" class="form-section">
            <span>
                <div class="d-flex flex-row align-items-center justify-content-between mb-8">
                    <div class="d-flex flex-column" style="width: 90%">
                        <div class="mat-body-2 text-black mb-0">{{ schedulersData.formData.title }}</div>
                        <div class="mat-subtitle-2 text-hint mb-0">
                            <span>{{ generalMessages.TIMEZONE_NOTE }} </span>
                            <span *ngIf="timeZoneData" class="secondary-text">{{ timeZoneData.timezone_label }} ({{ timeZoneData.timezone_abbr }})</span>
                        </div>
                    </div>

                    <button mat-icon-button (click)="closeForm()">
                        <mat-icon class="text-hint">cancel</mat-icon>
                    </button>
                </div>
                <mat-divider></mat-divider>

                <div class="mb-16">
                    <ng-container *ngIf="formErrors?.duplicateTime?.length">
                        <ng-container 
                            *ngTemplateOutlet="contentWithLinkTemp; context: {data: formErrors?.duplicateTime}"
                            ></ng-container>
                    </ng-container>
                    <ng-container *ngIf="formErrors?.inValidTime?.length">
                        <ng-container 
                            *ngTemplateOutlet="contentWithLinkTemp; context: {data: formErrors?.inValidTime}"
                            ></ng-container>
                    </ng-container>
                </div>

                <mat-card>
                    <app-scheduler-fields [orgTimeZone]="timeZoneData" [timeIntervalMinutes]="timeIntervalMinutes" #scheduleFieldsCompRef style="margin: 20px 8px 24px 8px;"> </app-scheduler-fields>
                </mat-card>
            </span>

            <span>
                <mat-divider></mat-divider>
                <div class="d-flex align-items-center justify-content-end h-48">
                    <button mat-button color="accent" class="mx-8" (click)="closeForm()">
                        {{ schedulersData.formData.buttons[0] }}
                    </button>
                    <button mat-button color="accent" (click)="addSchedule()">
                        {{ schedulersData.formData.buttons[1] }}
                    </button>
                </div>
            </span>
        </div>
    </ng-template>
</ng-container>

        
<ng-template #contentWithLinkTemp let-contentData="data">
    <mat-card appearance="outlined" class="notify-warn-card error-warn mat-elevation-z0 mt-16">
        <div class="d-flex align-items-center">
            <mat-icon>error</mat-icon>
            <div class="mat-subtitle-2 m-0">{{contentData}}</div>
        </div>
    </mat-card>
</ng-template>